import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import RequirePermission from "../../../auth/RequirePermission";
import { ADMIN_PERMISSIONS } from "../../../auth/adminPermissions";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import AdminStatePanel from "../../../components/midpoint/admin/layout/AdminStatePanel";
import AdminTableContainer from "../../../components/midpoint/admin/layout/AdminTableContainer";
import { fetchTrustSafetyCases } from "../../../services/automapTrustSafetyApi";
import { trackTrustSafetyEvent } from "../../../constants/automapTrustSafetyConstants";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import {
  CASE_STATUS_LABELS,
  CASE_TYPE_LABELS,
  SEVERITY_CLASS,
  SEVERITY_LABELS,
  TrustSafetyNav,
  formatDate,
} from "./trustSafetyShared";

function AdminTrustSafetyCasesPageContent() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const status = searchParams.get("status") || "";
  const severity = searchParams.get("severity") || "";

  useEffect(() => {
    const params = { openOnly: !status ? "true" : undefined, sort: "severity" };
    if (status) params.status = status;
    if (severity) params.severity = severity;
    setLoading(true);
    fetchTrustSafetyCases(params)
      .then((data) => { setCases(data.cases || []); trackTrustSafetyEvent("trust_case_opened"); })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [status, severity]);

  return (
    <AdminPageLayout>
      <AdminAutomotiveNav active="trust-safety" />
      <AdminPageHeader
        eyebrow="AutoMapa · Confianza"
        title="Casos"
        navigation={<TrustSafetyNav active="cases" />}
      />
      <main className="admin-console__main">
        <div className="admin-filters" style={{ marginBottom: "1rem" }}>
          <select value={severity} onChange={(e) => { const p = new URLSearchParams(searchParams); if (e.target.value) p.set("severity", e.target.value); else p.delete("severity"); setSearchParams(p); }}>
            <option value="">Severidad</option>
            {Object.entries(SEVERITY_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
          <select value={status} onChange={(e) => { const p = new URLSearchParams(searchParams); if (e.target.value) p.set("status", e.target.value); else p.delete("status"); setSearchParams(p); }}>
            <option value="">Estado</option>
            {Object.entries(CASE_STATUS_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        </div>
        {error ? <AdminStatePanel variant="empty" message={error} /> : null}
        {loading ? <AdminStatePanel variant="empty" message="Cargando casos…" /> : cases.length === 0 ? (
          <AdminStatePanel variant="empty" message="No hay casos." />
        ) : (
          <AdminTableContainer>
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Título</th><th>Tipo</th><th>Dealer</th><th>Listing</th><th>Estado</th><th>Severidad</th><th>Reportes</th><th>Actualizado</th><th></th>
                </tr>
              </thead>
              <tbody>
                {cases.map((c) => (
                  <tr key={c.id}>
                    <td>{c.title}</td>
                    <td>{CASE_TYPE_LABELS[c.caseType] || c.caseType}</td>
                    <td>{c.dealerName || "—"}</td>
                    <td>{c.listingTitle || "—"}</td>
                    <td>{CASE_STATUS_LABELS[c.status] || c.status}</td>
                    <td><span className={`admin-badge ${SEVERITY_CLASS[c.severity]}`}>{SEVERITY_LABELS[c.severity]}</span></td>
                    <td>{c.reportCount}</td>
                    <td>{formatDate(c.updatedAt)}</td>
                    <td><Link to={`/admin/trust-safety/cases/${c.id}`}>Ver</Link></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </AdminTableContainer>
        )}
      </main>
    </AdminPageLayout>
  );
}

export default function AdminTrustSafetyCasesPage() {
  return (
    <RequirePermission permission={ADMIN_PERMISSIONS.REAL_ESTATE_SOURCES_VIEW}>
      <AdminTrustSafetyCasesPageContent />
    </RequirePermission>
  );
}
